"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CartItemPromoState_1 = require("./CartItemPromoState");
var styles = require("./CartItemPromo.scss");
var ui_components_1 = require("@idp/ui-components");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var icons = require("../../../styles/ccc-icons-cart.scss");
var CartItemPromo = /** @class */ (function (_super) {
    __extends(CartItemPromo, _super);
    function CartItemPromo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new CartItemPromoState_1.default();
        _this.showPriceContent = _this.showPriceContent.bind(_this);
        return _this;
    }
    CartItemPromo.prototype.render = function () {
        this.testIdVal = this.props.options && this.props.options.testId || 'CartItem';
        var promoTextStyle = this.props.data.isExpressUpgradeView ? styles.expupPromoText : styles.promoText;
        var imageStyle = (CartUtilFunctions_1.isAppreciationOfferPresent()) ?
            [icons.cccIconCart, icons.cccIconCartSavingsAppreciation32, styles.iconBookmark32].join(' ')
            : [icons.cccIconCart, icons.cccIconCartSignatureBookmark, styles.iconBookmark32].join(' ');
        return this.props.data.promoText && (React.createElement("div", { className: styles.cartItemPromoContainer },
            React.createElement("div", { className: promoTextStyle },
                this.props.data.isSignaturePromo && !CartUtilFunctions_1.isSMBCustomer() && !CartUtilFunctions_1.isFNIntentPresent() &&
                    !CartUtilFunctions_1.isFNUserWithConsumerLine() &&
                    React.createElement("span", null,
                        React.createElement("i", { "aria-label": "Icon", className: imageStyle })),
                React.createElement(ui_components_1.RichText, { testId: this.testIdVal + '_PromoName', data: { isDecodingRequired: false, text: this.props.data.promoText } })),
            React.createElement("div", { className: styles.promoPrice }, this.showPriceContent()))) || React.createElement(React.Fragment, null);
    };
    CartItemPromo.prototype.showPriceContent = function () {
        if (this.props.data && this.props.data.showPrice && this.props.data.promoPrice) {
            var promoPriceObj = wlsUtils.promoCyclePriceMsg(this.props.data.promoPrice, this.props.data.promotionCycle, this.props.data.isPriceNegative);
            return (React.createElement(ui_components_1.PriceContainer, { testId: this.testIdVal + '_PromoPrice', data: { billingNote: promoPriceObj.suffix, price: this.props.data.promoPrice }, options: { accessibility: promoPriceObj.catoConten, decimalPoints: 2,
                    isDataPriceNegative: this.props.data.isPriceNegative,
                    overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }));
        }
        else {
            return (React.createElement("div", { className: styles.promoNoprice }, "\u00A0"));
        }
    };
    return CartItemPromo;
}(React.Component));
exports.default = CartItemPromo;
//# sourceMappingURL=CartItemPromo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/CartItemPromo/CartItemPromo.js
// module id = 2280
// module chunks = 8